// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__slot":"BaseModalContent_pintxo-modal__slot__iXvVs"};